module.exports = __webpack_public_path__ + "static/media/blue-plane.2a2e318a.svg";